import { Link } from 'react-router-dom';
import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import CookieBanner from '../../components/feature/CookieBanner';

export default function About() {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxImage, setLightboxImage] = useState('');

  const openLightbox = (imageSrc: string) => {
    setLightboxImage(imageSrc);
    setLightboxOpen(true);
  };

  const closeLightbox = () => {
    setLightboxOpen(false);
    setLightboxImage('');
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <main className="pt-32 pb-20">
        <div className="max-w-[1200px] mx-auto px-6">
          <article>
            <header className="mb-12">
              <h1 className="text-5xl font-bold text-primary mb-4">Hakkımızda</h1>
              <p className="text-xl text-gray-600">
                Bursa'da tente ve pergola sistemlerinde 15 yılı aşkın deneyim
              </p>
            </header>

            <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
              <div className="space-y-6">
                <h2 className="text-3xl font-bold text-primary">Bursa Tente: Güven ve Kalite</h2>
                <p className="text-gray-700 leading-relaxed">
                  <strong>Bursa Tente</strong> olarak 2008 yılından bu yana Bursa genelinde tente, <strong>pergola</strong> ve gölgelendirme sistemleri alanında hizmet vermekteyiz. 15 yılı aşkın deneyimimizle binlerce konut, işyeri ve ticari alana estetik ve fonksiyonel çözümler sunarak müşterilerimizin yaşam alanlarını daha konforlu hale getiriyoruz.
                </p>
                <p className="text-gray-700 leading-relaxed">
                  Modern teknoloji ile geleneksel kalite anlayışını bir araya getiren firmamız, <strong>körüklü tente</strong>, <strong>mafsallı tente</strong>, <strong>bioklimatik pergola</strong>, otomatik pergola, <strong>zip perde</strong>, şeffaf stor ve daha birçok ürün grubuyla sektörde öncü konumdadır.
                </p>
              </div>
              <div className="relative rounded-3xl overflow-hidden shadow-xl h-64 md:h-96 cursor-pointer" onClick={() => openLightbox('https://public.readdy.ai/ai/img_res/6a9cb6f2a0ce8d698145dc0649a5b2d4.jpg')}>
                <img
                  src="https://readdy.ai/api/search-image?query=Professional%20awning%20and%20pergola%20installation%20team%20working%20on%20luxury%20residential%20project%20in%20Bursa%20Turkey%2C%20skilled%20craftsmen%20installing%20modern%20bioclimatic%20system%2C%20high%20quality%20workmanship%2C%20outdoor%20construction%20scene%2C%20team%20collaboration%2C%20architectural%20excellence%2C%20natural%20daylight%20photography%2C%20simple%20background&width=800&height=600&seq=about1&orientation=landscape"
                  alt="Bursa Tente Profesyonel Ekip"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
            </div>

            <section className="mb-12 md:mb-20">
              <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
                {[
                  {
                    icon: 'ri-award-line',
                    title: '15+ Yıl Deneyim',
                    description: 'Sektörde uzun yılların getirdiği bilgi birikimi ve uzmanlık',
                  },
                  {
                    icon: 'ri-team-line',
                    title: 'Profesyonel Ekip',
                    description: 'Alanında uzman, sertifikalı montaj ekibimiz',
                  },
                  {
                    icon: 'ri-shield-check-line',
                    title: 'Garanti',
                    description: 'Tüm ürün ve işçilikte uzun süreli garanti',
                  },
                  {
                    icon: 'ri-price-tag-3-line',
                    title: 'Uygun Fiyat',
                    description: 'Kaliteden ödün vermeden en rekabetçi fiyatlar',
                  },
                  {
                    icon: 'ri-customer-service-2-line',
                    title: 'Müşteri Memnuniyeti',
                    description: '7/24 destek ve satış sonrası hizmet',
                  },
                  {
                    icon: 'ri-search-eye-line',
                    title: 'Ücretsiz Keşif',
                    description: 'Yerinde ölçüm ve detaylı proje planlaması',
                  },
                ].map((item, index) => (
                  <div
                    key={index}
                    className="text-center bg-gradient-to-br from-primary to-primary/80 text-white rounded-2xl p-6 md:p-8 shadow-lg"
                  >
                    <div className="w-12 h-12 bg-secondary/10 rounded-lg flex items-center justify-center mb-4">
                      <i className={`${item.icon} text-2xl text-secondary`}></i>
                    </div>
                    <h3 className="text-xl font-bold text-primary mb-2">{item.title}</h3>
                    <p className="text-gray-600 text-sm">{item.description}</p>
                  </div>
                ))}
              </div>
            </section>

            <section className="bg-primary text-white rounded-2xl p-8 md:p-12 text-center">
              <h2 className="text-2xl md:text-4xl font-bold mb-4 md:mb-6">Hemen Teklif Alın</h2>
              <p className="text-base md:text-xl mb-6 md:mb-8 max-w-2xl mx-auto">
                Projeleriniz için ücretsiz keşif ve detaylı fiyat teklifi almak ister misiniz?
              </p>
              <a
                href="https://wa.me/905421821925?text=Merhaba,%20tente%20hakkında%20bilgi%20almak%20istiyorum"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 md:gap-3 bg-white text-primary px-6 md:px-8 py-3 md:py-4 rounded-full text-base md:text-lg font-bold hover:bg-gray-100 transition-all cursor-pointer"
              >
                <i className="ri-whatsapp-fill text-xl md:text-2xl"></i>
                WhatsApp ile İletişime Geç
              </a>
            </section>
          </article>
        </div>
      </main>

      <Footer />
      <CookieBanner />

      {/* Lightbox Modal */}
      {lightboxOpen && (
        <div
          className="fixed inset-0 bg-black/95 z-[100] flex items-center justify-center p-4 cursor-pointer"
          onClick={closeLightbox}
        >
          <button
            className="absolute top-4 right-4 w-12 h-12 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center text-white text-2xl transition-colors"
            onClick={closeLightbox}
            aria-label="Kapat"
          >
            <i className="ri-close-line"></i>
          </button>
          <img
            src={lightboxImage}
            alt="Büyütülmüş görsel"
            className="max-w-full max-h-full object-contain"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </div>
  );
}